import React from "react";
import "./windDirectionAnimation.css";
import windDirectionSvg from "./WindDirectionSvg.svg";

function toRad(degrees) {
  return degrees * (Math.PI / 180);
}

export default function WindDirectionBackground({ windDirection }) {
  if (windDirection === 0) return null;

  const deg = windDirection;
  const w =
    window.innerHeight * Math.abs(Math.sin(toRad(deg))) +
    window.innerWidth * Math.abs(Math.cos(toRad(deg)));
  const h =
    window.innerWidth * Math.abs(Math.sin(toRad(deg))) +
    window.innerHeight * Math.abs(Math.cos(toRad(deg)));

  const deltaX = (window.innerWidth - w) / 2;
  const deltaY = (window.innerHeight - h) / 2;

  return (
    <div
      aria-hidden="true"
      className="fixed pointer-events-none select-none z-0"
      style={{
        opacity: 0.05,
        top: deltaY,
        left: deltaX,
        width: w,
        height: h,
        background: `url('${windDirectionSvg}')`,
        animation: "animateBackground 3s linear infinite",
        transform: `rotate(${deg}deg)`,
        transformOrigin: "center center",
      }}
    />
  );
}
